/**
 * Buggino – Conversion-Layer:
 *  1. Suchvorschläge im Header (Shopify Predictive Search, /search/suggest.json)
 *  2. „Passt dazu“ im Warenkorb (Produktempfehlungen, /recommendations/products.json)
 *  3. Newsletter-Popup mit Willkommenscode (verzögert, höchstens alle 14 Tage)
 */
(function () {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) =>
    window.Buggino && window.Buggino.formatMoney
      ? window.Buggino.formatMoney(cents, document.documentElement.dataset.moneyFormat || '')
      : (cents / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const img = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const store = {
    get(k) {
      try {
        return window.localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set(k, v) {
      try {
        window.localStorage.setItem(k, v);
      } catch (e) {
        /* privater Modus */
      }
    },
  };

  /* ---------------------------------------------------------------- 1. Suchvorschläge */
  function initPredictiveSearch() {
    const input = document.getElementById('header-search');
    if (!input) return;
    const form = input.closest('form');
    const i18n = document.querySelector('[data-search-i18n]');
    const t = (k) => (i18n ? i18n.dataset[k] || '' : '');
    const box = document.createElement('div');
    box.className = 'search-suggest';
    box.id = 'search-suggest';
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    form.insertAdjacentElement('afterend', box);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'search-suggest');
    input.setAttribute('aria-expanded', 'false');

    let timer = null;
    let controller = null;
    let active = -1;

    const close = () => {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    };

    async function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      const url =
        root +
        'search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product,collection,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      try {
        const res = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('suggest');
        const data = await res.json();
        render(q, (data.resources && data.resources.results) || {});
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    }

    function render(q, r) {
      const products = (r.products || []).slice(0, 5);
      const collections = (r.collections || []).slice(0, 3);
      const articles = (r.articles || []).slice(0, 2);
      let html = '';
      if (products.length) {
        html += '<p class="search-suggest__label">' + esc(t('products')) + '</p><ul class="search-suggest__list">';
        products.forEach((p) => {
          const price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
          const image = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          html +=
            '<li><a class="search-suggest__item" role="option" href="' +
            esc(p.url) +
            '">' +
            (image ? '<img src="' + esc(img(image, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="search-suggest__ph"></span>') +
            '<span class="search-suggest__text"><span class="search-suggest__title">' +
            esc(p.title) +
            '</span><span class="search-suggest__price">' +
            esc(price) +
            '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (collections.length) {
        html += '<p class="search-suggest__label">' + esc(t('collections')) + '</p><ul class="search-suggest__chips">';
        collections.forEach((c) => {
          html += '<li><a class="chip" role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        });
        html += '</ul>';
      }
      if (articles.length) {
        html += '<p class="search-suggest__label">' + esc(t('articles')) + '</p><ul class="search-suggest__links">';
        articles.forEach((a) => {
          html += '<li><a role="option" href="' + esc(a.url) + '">' + esc(a.title) + '</a></li>';
        });
        html += '</ul>';
      }
      if (!html) html = '<p class="search-suggest__empty">' + esc(t('empty')) + '</p>';
      html +=
        '<a class="search-suggest__all" href="' +
        esc(root + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last') +
        '">' +
        esc(t('all').replace('[terms]', q)) +
        ' →</a>';
      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }

    input.addEventListener('input', () => {
      const q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        close();
        return;
      }
      timer = window.setTimeout(() => run(q), 180);
    });

    input.addEventListener('keydown', (e) => {
      const items = Array.from(box.querySelectorAll('a'));
      if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = e.key === 'ArrowDown' ? (active + 1) % items.length : (active - 1 + items.length) % items.length;
        items.forEach((a, i) => a.classList.toggle('is-active', i === active));
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active >= 0) {
        e.preventDefault();
        window.location.href = items[active].href;
      } else if (e.key === 'Escape') {
        close();
      }
    });

    const details = input.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open) window.setTimeout(() => input.focus(), 30);
        else close();
      });
    }
  }

  /* Zubehör je Produkttyp (deutscher Shopify-Produkttyp, in allen Sprachen gleich) */
  const ACC = [
    [/kinderwagen|zwillingswagen|buggy(?!board)|reisebuggy/i, ['buggino-regenschutz-universal', 'buggino-organizer-kinderwagen', 'buggino-moskitonetz-kinderwagen', 'buggino-buggyboard-sitz-2in1', 'buggino-flaschenhalter-kinderwagen', 'buggino-handwaermer-kinderwagen']],
    [/babybett|beistellbett|wiege|reisebett|babynest|bettgitter/i, ['buggino-nachtlicht-touch-13-farben', 'buggino-babyphone-5-zoll-ptz', 'buggino-sternenhimmel-projektor', 'buggino-stillkissen-u']],
    [/hochstuhl|sitzerhöhung/i, ['buggino-sitzerhoehung-klappbar', 'buggino-lernturm-3in1', 'buggino-beissring-holz-silikon']],
    [/trage|sling|hüftsitz/i, ['buggino-wickeltasche-rucksack', 'buggino-wickelmatte-reise', 'buggino-beissring-holz-silikon']],
    [/laufgitter|spielmatte/i, ['buggino-spielmatte-faltbar', 'buggino-treppenschutzgitter-ausziehbar', 'buggino-beissring-zahnbuerste-banane']],
    [/lauflern/i, ['buggino-treppenschutzgitter-ausziehbar', 'buggino-spielmatte-faltbar']],
    [/badewanne/i, ['buggino-wickelauflage-konturiert', 'buggino-badewanne-kissen-thermo', 'buggino-wickelmatte-reise']],
    [/wickel/i, ['buggino-wickelmatte-reise', 'buggino-wickeltasche-rucksack', 'buggino-organizer-kinderwagen']],
    [/kissen/i, ['buggino-nachtlicht-touch-13-farben', 'buggino-beistellbett-cododo']],
    [/toilette|tritthocker|lernturm/i, ['buggino-tritthocker-holz-2-stufen', 'buggino-toilettentrainer-leiter']],
    [/babyphone|nachtlicht|projektor/i, ['buggino-nachtlicht-touch-13-farben', 'buggino-sternenhimmel-projektor', 'buggino-babyphone-5-zoll-ptz']],
    [/wippe|schaukel/i, ['buggino-spielmatte-faltbar', 'buggino-babyphone-5-zoll-ptz', 'buggino-beissring-holz-silikon']],
    [/treppenschutz/i, ['buggino-laufgitter-tor', 'buggino-bettgitter-klassik']],
    [/regenschutz|moskito|organizer|flaschen|handwärmer|mitfahr/i, ['buggino-organizer-kinderwagen', 'buggino-regenschutz-universal', 'buggino-flaschenhalter-kinderwagen', 'buggino-moskitonetz-kinderwagen']],
    [/beißring/i, ['buggino-beissring-holz-silikon', 'buggino-beissring-zahnbuerste-banane']],
  ];
  function accessoriesFor(type) {
    for (const [re, list] of ACC) if (re.test(type)) return list;
    return [];
  }

  /* ---------------------------------------------------------------- 2. „Passt dazu“ im Warenkorb */
  function initCartUpsell() {
    const drawer = document.querySelector('[data-cart-drawer]');
    const box = drawer && drawer.querySelector('[data-cart-upsell]');
    if (!box) return;
    const list = box.querySelector('[data-cart-upsell-list]');
    const addLabel = box.dataset.addLabel || '+';
    let lastKey = '';

    async function update() {
      try {
        const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        if (!cart.items || !cart.items.length) {
          box.hidden = true;
          return;
        }
        const inCart = new Set(cart.items.map((i) => i.product_id));
        const inCartHandles = new Set(cart.items.map((i) => i.handle));
        const anchor = cart.items[0]; // zuletzt hinzugefügter Artikel steht oben
        const key = anchor.product_id + ':' + Array.from(inCart).join(',');
        if (key === lastKey) return;
        lastKey = key;
        let picks = [];
        const handles = accessoriesFor(anchor.product_type || '').filter((h) => !inCartHandles.has(h));
        if (handles.length) {
          const got = await Promise.all(
            handles.slice(0, 6).map((h) =>
              fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
                .then((r) => (r.ok ? r.json() : null))
                .catch(() => null)
            )
          );
          picks = got.filter((p) => p && p.available && !inCart.has(p.id)).slice(0, 3);
        }
        if (picks.length < 2) {
          const res = await fetch(root + 'recommendations/products.json?product_id=' + anchor.product_id + '&limit=10&intent=related', {
            headers: { Accept: 'application/json' },
          });
          if (res.ok) {
            const data = await res.json();
            const have = new Set(picks.map((p) => p.id));
            (data.products || [])
              .filter((p) => p.available && !inCart.has(p.id) && !have.has(p.id) && p.type !== anchor.product_type)
              .forEach((p) => {
                if (picks.length < 3) picks.push(p);
              });
          }
        }
        if (!picks.length) {
          box.hidden = true;
          return;
        }
        list.innerHTML = picks
          .map((p) => {
            const v = (p.variants || []).find((x) => x.available) || p.variants[0];
            const image = p.featured_image ? img(p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image, 140) : '';
            const title = p.title.replace(/^Buggino\s+/, '');
            return (
              '<li class="cart-upsell__item">' +
              '<a href="' + esc(root + 'products/' + p.handle) + '" class="cart-upsell__img" tabindex="-1" aria-hidden="true">' +
              (image ? '<img src="' + esc(image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
              '</a><div class="cart-upsell__info"><a class="cart-upsell__title" href="' + esc(p.url) + '">' + esc(title) + '</a>' +
              '<span class="cart-upsell__price">' + esc(money(v ? v.price : p.price)) + '</span></div>' +
              '<button type="button" class="btn btn--secondary btn--sm" data-upsell-add="' + (v ? v.id : '') + '">' + esc(addLabel) + '</button>' +
              '</li>'
            );
          })
          .join('');
        box.hidden = false;
      } catch (e) {
        box.hidden = true;
      }
    }

    box.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-upsell-add]');
      if (!btn || !btn.dataset.upsellAdd) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.upsellAdd), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        lastKey = '';
        window.setTimeout(update, 400);
      } catch (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    });

    new MutationObserver(() => {
      if (drawer.open) update();
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('cart:added', () => window.setTimeout(update, 250));
  }

  /* ---------------------------------------------------------------- 3. Newsletter-Popup */
  function initNewsletterPopup() {
    const dlg = document.querySelector('[data-nl-popup]');
    if (!dlg) return;
    const KEY = 'bg_nl_state';
    const DAY = 864e5;
    const open = () => {
      if (dlg.open || document.querySelector('dialog[open]')) return;
      window.Buggino && window.Buggino.openDialog ? window.Buggino.openDialog(dlg) : dlg.showModal();
    };
    const close = () => {
      window.Buggino && window.Buggino.closeDialog ? window.Buggino.closeDialog(dlg) : dlg.close();
    };
    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-nl-close]') || e.target === dlg) {
        if (!dlg.querySelector('[data-nl-success]')) store.set(KEY, 'dismissed:' + Date.now());
        close();
      }
    });
    dlg.addEventListener('cancel', () => {
      if (!dlg.querySelector('[data-nl-success]')) store.set(KEY, 'dismissed:' + Date.now());
    });

    // Rückkehr nach dem Absenden → Erfolg + Code anzeigen
    const posted = /customer_posted=true/.test(window.location.search);
    if (posted) {
      store.set(KEY, 'subscribed');
      if (window.location.hash === '#newsletter-popup' && dlg.querySelector('[data-nl-success]')) {
        window.setTimeout(open, 300);
      }
      return;
    }

    const state = store.get(KEY) || '';
    if (state === 'subscribed') return;
    if (state.startsWith('dismissed:') && Date.now() - Number(state.split(':')[1]) < 14 * DAY) return;
    const tpl = document.body.dataset.template || '';
    if (/^(cart|password|customers|gift_card)/.test(tpl)) return;

    let fired = false;
    const fire = () => {
      if (fired) return;
      fired = true;
      cleanup();
      open();
    };
    const timer = window.setTimeout(fire, 35000);
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.6 && performance.now() > 15000) fire();
    };
    const onLeave = (e) => {
      if (e.clientY <= 0 && performance.now() > 8000) fire();
    };
    function cleanup() {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
  }

  function init() {
    initPredictiveSearch();
    initCartUpsell();
    initNewsletterPopup();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
